document.addEventListener('DOMContentLoaded', function() {
  const videoWrapper = document.querySelector('.assembly-guide-content-video');
  const video = videoWrapper?.querySelector('video');
  const playIcon = videoWrapper?.querySelector('.assembly-guide-content-video-icon');

  if (!video || !videoWrapper) return;

  videoWrapper.addEventListener('click', function() {
    if (video.paused) {
      video.play();
      playIcon.style.opacity = '0';
      playIcon.style.pointerEvents = 'none';
    } else {
      video.pause();
      playIcon.style.opacity = '1';
      playIcon.style.pointerEvents = 'auto';
    }
  });

  // Hide play icon when video is playing
  video.addEventListener('play', function() {
    playIcon.style.opacity = '0';
    playIcon.style.pointerEvents = 'none';
  });

  // Show play icon when video is paused
  video.addEventListener('pause', function() {
    playIcon.style.opacity = '1';
    playIcon.style.pointerEvents = 'auto';
  });
});
